module.exports = __webpack_public_path__ + "static/media/paymentDay.6d718052.svg";